import React from "react"
import LinkButton from "@components/common/LinkButton"
import { DotIcon } from "@phosphor-icons/react"

// assets
import BBLogo from "../../image/logos/bb-logo-svg.svg"
import visaLogo from "@images/logos/payment-methods/visa.svg"
import mastercardLogo from "@images/logos/payment-methods/mastercard.svg"
import unionpayLogo from "@images/logos/payment-methods/union-pay.svg"
import amexLogo from "@images/logos/payment-methods/amex.svg"
import jcbLogo from "@images/logos/payment-methods/jcb.svg"

const CopyrightSection = () => {

  return (
    <React.Fragment>
      <section className="max-container flex gap-x-6 items-start py-8">
        <img src={BBLogo} alt='Blackbough Swim Logo' />
        <div className="flex flex-col lg:flex-row items-start lg:justify-between lg:items-center gap-2 w-full">
          <div>
            <div>© 2025 Blackbough Swim</div>
            <div className="flex justify-start flex-wrap text-[#888888] text-sm">
              <LinkButton label={'Privacy Policy'} to="/privacy-policy" underlineOnHover />
              <DotIcon size={28} />
              <LinkButton label={'Terms & Conditions'} to="/terms-and-conditions" underlineOnHover />
              <DotIcon size={28} />
              <LinkButton label={'Return & Refund Policy'} to="https://black-bough-swim.reamaze.com/kb/returns" underlineOnHover />
              <DotIcon size={28} />
              <LinkButton label={'Shipping Policy'} to="https://black-bough-swim.reamaze.com/kb/shipping" underlineOnHover />
            </div>
          </div>

          <div className="inline-flex gap-2 footer-payment-methods">
            <img src={visaLogo} alt='Visa' />
            <img src={mastercardLogo} alt='MasterCard' />
            <img src={unionpayLogo} alt='Union Pay' />
            <img src={amexLogo} alt='AMEX' />
            <img src={jcbLogo} alt='JCB' />
          </div>
        </div>
      </section>
    </React.Fragment>
  )
}

export default CopyrightSection